import React, { useEffect } from 'react';
import EventSystem from './EventSystem';

export default function WeatherDisplayModule({ parameters, onSendMessage }) {
    useEffect(() => {
        EventSystem.subscribe('WeatherDisplaylModule', showMessage);
        onSendMessage({
            sourceModuleName: parameters.config.module_name,
            event_grouping_seq: parameters.config.event_grouping_seq,
            customerID: parameters.userProfile.customer_id,
            siteID: parameters.userProfile.site_id,
            eventID: parameters.config.event_id,
        });
        return () => EventSystem.unsubscribe('WeatherDisplaylModule');
    }, []);

    function showMessage(_data) {
        // weather display not yet implemented
    }

    return <div />;
}
